document.addEventListener('DOMContentLoaded', () => {
    const searchTriggers = document.querySelectorAll('.search-toggle, #search-close');
    const siteSearch = document.querySelector('#site-search');
    const searchField = document.querySelector('.search-field');
    
    function toggleSearch(e) {
        e.preventDefault();
        siteSearch?.classList.toggle('open');
    
        if (siteSearch?.classList.contains('open')) {
            searchField?.focus();
        }
    }

    searchTriggers.forEach((trigger) => {
        trigger.addEventListener('click', toggleSearch);
    });
});
